import React, { useContext, useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import moment from "moment";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import XCloseIcon from "../../../../component/icons/x-close";
import Chip from "../../../../component/ui/chip";
import Tooltip from "../../../../component/ui/tooltip";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
  TableSort,
} from "../../../../component/table/table-layout";
import { CheckCircle, CircleFadingPlus, FileVolume, Loader2, Pause, Play, PlayCircle, PlusIcon, UserPlus } from "lucide-react";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import AudioPlayer from "../../../../component/ui/audio-player";
import AddFullModal from "../../StepForm/AddFullModal";
import { GlobalContext } from "../../../../context/Context";
import CallQuickView from "../../DetailsPopup";
import Swal from "sweetalert2";
import { useNavigate } from 'react-router';
import ProgressLine from "../../../../component/ui/ProgressBar";
import StatusChip from "../../../../component/ui/chip/status";




const QACalls = () => {

  const mType = "call"
  const navigate = useNavigate()

  let { state } = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeader, setTableHeader] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [showAddModal, setAddModal] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const [showQuickView, setQuickView] = useState(false)
  const [CallData, setCallData] = useState({})


  const [sortFields, setSortFields] = useState([]);
  const [selectFilterName, setSelectFilterName] = useState("My Filter");
  const [editingFilters, setEditingFilters] = useState(null);


  const [activeAudioId, setActiveAudioId] = useState(null); // currently playing row id
  const [activeAudioLink, setActiveAudioLink] = useState(""); // src

  const [Dropdowns, setDropdowns] = useState({});
  const [loadingTranscriptId, setLoadingTranscriptId] = useState(null);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getOtherDropdowns({})
  }, []);




  const filterData = ({
    filters = filterReturn,
    page = pageCount,
    page_quantity = pageItemsCount,
    sortField = sortFields,
    btnCall = false,
  }) => {
    const sort_by = sortField[0]?.field || null;
    const sort_direction = sortField[0]?.order || null;
    const data = {
      page,
      page_quantity,
      filters,
      sort_by,
      sort_direction,
      btnCall,
    };
    getData(data);
  };

  const getData = async (data = null) => {
    if (data?.btnCall) {
      setBtnLoader(true);
    } else {
      setIsLoading(true);
    }
    let urlData = ``;
    if (data) {
      urlData = !data?.page
        ? `?page_quantity=10&page=1`
        : `?page=${data?.page}${data?.page_quantity !== "all"
          ? `&page_quantity=${data?.page_quantity}`
          : ""
        }`;
      if (data?.filters) {
        data?.filters.forEach((el) => {
          const key = el.field || el.name; // support both
          if (key === "date_filter" && el.value === "between") {
            if (el.startDate) {
              urlData += `&date_filter=custom&start_date=${el?.startDate}`;
            }
            if (el.endDate) {
              urlData += `&end_date=${el?.endDate}`;
            }
          } else if (el?.value !== "" && el?.value != null) {
            urlData += `&${key}=${el.value}`;
          }
        });
      }
      if (data?.sort_by && data?.sort_direction) {
        urlData += `&sort_by=${data.sort_by}&sort_direction=${data.sort_direction}`;
      }
    }

    try {
      let res = await apiCall({
        url: `get-flag-to-qa-call-logs-list${urlData}`,
        method: "get",
      });
      if (data?.btnCall) {
        setBtnLoader(false);
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Err", error);
    }
  };

  const Assigned = async (id) => {
    try {
      let apiRes = await apiCall({ method: "post", url: "call-meeting-assign-to-me", data: { id: id, type: mType } })
      Swal.fire({
        title: "Assigned",
        text: apiRes?.message || "Assigned successfully",
        icon: "success",
        timer: 5000,
        showConfirmButton: false,
        timerProgressBar: true
      });

      getData({});

    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err?.message || "Something went wrong",
        icon: "error",
        timer: 5000,
        showConfirmButton: false,
        timerProgressBar: true
      });

    }
  }

  const onSuccess = (message, id) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setAddModal(false);
    getData({})

    setQuickView(true);
    setCallData({ id });
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const removeFilter = (fIndex) => {
    let allFilter = [...filterReturn];
    allFilter.splice(fIndex, 1);
    setFilterReturn(allFilter);
    getData({ filter: allFilter });
  };

  let agentList = state?.DropdownData?.agentList || {};

  const getOtherDropdowns = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "get-step-form-dropdown-list",
      });

      setDropdowns(res?.data || []);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    }
  };

  const filterModalData = [
    // {
    //   name: "date_range",
    //   label: "By Date",
    //   options: ["is", "between"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "dropdown",
    //   dropdown: [
    //     { label: "Today", value: "today" },
    //     { label: "Yesterday", value: "yesterday" },
    //     { label: "This Week", value: "this_week" },
    //     { label: "This Month", value: "this_month" },
    //   ],
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    //   betweenType: "date",
    // },
    {
      name: "date_range",
      label: "By Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "date",
      betweenType: "date",
    },

    {
      name: "agent_id",
      label: "By Agent",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: agentList,
      dropdownKey: "name",
      dropdownVal: "userid",
      betweenType: "date",
    },

    {
      name: "status",
      label: "By Status",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: Dropdowns?.status,
      dropdownKey: "name",
      dropdownVal: "name",
    },

    {
      name: "direction",
      label: "By Direction",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: Dropdowns?.directions,
      dropdownKey: "name",
      dropdownVal: "name",
    },

    {
      name: "c_type",
      label: "By C Type",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: Dropdowns?.c_type,
      dropdownKey: "name",
      dropdownVal: "name",
    },

    {
      name: "merchant_id",
      label: "By Merchant",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: Dropdowns?.merchant,
      dropdownKey: "name",
      dropdownVal: "id",
    },

    {
      name: "stage",
      label: "By Stage",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: Dropdowns?.stages,
      dropdownKey: "name",
      dropdownVal: "name",
    },

    {
      name: "receiver_number",
      label: "By Reciver Number",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "text",
    },

    {
      name: "caller_number",
      label: "By Caller Number",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "text",
    },

    {
      name: "call_id",
      label: "By Call Id",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "text",

    },

    {
      name: "unit_id",
      label: "By Unit",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state?.DropdownData?.businessUnits,
      dropdownKey: "label",
      dropdownVal: "value",
    }
  ];

  const editRefund = (ele) => {
    setCurrentData(ele);
    setAddModal(true)
  };

  const tableRef = useRef(null);

  const generateTranscript = async (callId) => {
    setLoadingTranscriptId(callId);

    Swal.fire({
      title: "Generating Transcript...",
      html: "Please wait while processing",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    let sendData = JSON.stringify({
      id: callId,
      // id: 2,
      type: mType
    });

    try {
      let res = await apiCall({
        url: `generate-transcript`,
        method: "post",
        data: sendData,
      });


      Swal.fire({
        title: "Transcript Generated",
        text: res?.message || "Transcription completed successfully",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "View Transcript",
        cancelButtonText: "Close",
        // timer: 5000,             // Auto close in 5 sec
        // timerProgressBar: true
      }).then((result) => {
        // result.dismiss === Swal.DismissReason.timer means auto close
        if (result.isConfirmed) {
          window.open(`/billing/transciptDetail/${callId}/${mType}`, "_blank");
        }
      });

      getData({});

    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err?.message || "Something went wrong",
        icon: "error",
        timer: 5000,
        showConfirmButton: false,
        timerProgressBar: true
      });

    } finally {
      setLoadingTranscriptId(null);
    }
  };

  return (
    <>
      <div className={`${Style.mainBody}`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {filterReturn?.length ? (
                <div className={Style.filterContainer}>
                  <p className={Style.searchText}>Search By</p>

                  <TableFilterReturn
                    filterReturn={filterReturn}
                    onChange={(filters) => {
                      // console.log("filtersfiltersfilters", filters)
                      setFilterReturn(filters);
                      getData({ filter: filters });
                    }}
                  />
                </div>
              ) : null}

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {/* <div className={Style.bpfl_select}>
                    <select
                      onChange={(e) => {
                        getData({ page_quantity: e?.target.value });
                        setPageCount(1);
                        setPageItemsCount(e?.target.value);
                      }}
                    >
                      <option value="10">View 10</option>
                      <option value="25">View 25</option>
                      <option value="50">View 50</option>
                      <option value="100">View 100</option>
                      <option value="all">View all</option>
                    </select>
                  </div> */}

                  <div>
                    <h1 className="text-xl font-bold pl-3 flex items-center gap-1">
                      Call List
                    </h1>
                  </div>
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <div
                      className={Style.bpfl_action}
                      onClick={() => {
                        // setShowRefund(true);
                      }}
                    >
                      {/* <Tooltip
                        content={"Add Call Logs"}
                        position={"left center"}
                        className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                      >
                        <div className={Style.icon}>
                          <PlusIcon size="1em" />
                        </div>
                      </Tooltip> */}
                    </div>

                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                          }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <DataNotFound title={"Call Logs"} />
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              {/* <div className="flex gap-4 items-center">
                                <span>User Details</span>
                              </div> */}
                              <TableHeaderWrap>
                                <span>Call Id</span>
                              </TableHeaderWrap>
                            </TableCell>

                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                    {/* {eachHead?.sort_by ? (
                                      <TableSort
                                        field={eachHead?.key}
                                        sortFields={sortFields}
                                        onSort={handleSingleSort}
                                        Style={Style}
                                      />
                                    ) : (
                                      <TableSort
                                        disabled={true}
                                        field={eachHead?.key}
                                        Style={Style}
                                      />
                                    )} */}
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  {/* {eachList?.client_name ?? "-"} */}

                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    <div className="flex items-center gap-3">
                                      <div className="font-medium leading-5">
                                        {eachList?.call_id ?? "-"}
                                      </div>
                                    </div>

                                    <div className={Style.tableActionAreaBtnGrpup}>
                                      {eachList.is_completed ? (
                                        // Eye icon if completed
                                        <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() => {
                                            setQuickView(true);
                                            setCallData(eachList);
                                          }}
                                        >
                                          <div className={Style.icon} style={{ color: "#007AFF" }}>
                                            <NewEyeIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </div>
                                      ) : (
                                        // Pencil icon if not completed
                                        <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() => {
                                            editRefund(eachList);
                                          }}
                                        >
                                          <div className={Style.icon} style={{ color: "#FF9500" }}>
                                            <NewEditIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </div>
                                      )}


                                      {eachList?.recording_url ?
                                        eachList?.has_transcript ? (

                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                            onClick={() => window.open(`/billing/transciptDetail/${eachList.id}/${mType}`, "_blank")}
                                          >
                                            <div
                                              className={Style.icon} style={{ color: "#007AFF" }}

                                            >
                                              <FileVolume className="h-4 w-4" />
                                            </div>
                                          </div>
                                        ) : (
                                          // <div
                                          //   className="w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          //   onClick={() => generateTranscript(eachList.id)}
                                          // >
                                          //   <div className={Style.icon} style={{ color: "#007AFF" }}>
                                          //     <CircleFadingPlus className="h-4 w-4" />
                                          //   </div>
                                          // </div>

                                          null

                                        ) : null
                                      }

                                      {!eachList.is_assigned ?
                                        <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() => Assigned(eachList?.id)}
                                        >
                                          <div
                                            className={Style.icon} style={{ color: "#007AFF" }}

                                          >
                                            <UserPlus className="h-4 w-4" />
                                          </div>
                                        </div>

                                        : null
                                      }
                                    </div>

                                  </div>
                                </TableCell>

                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 && eachHead?.show === 1 ? (
                                    <TableCell key={`${i}-${index}`}>
                                      {eachHead.key === "recording_url" && eachList?.[eachHead.key] ? (
                                        <button
                                          onClick={() => {
                                            const id = eachList?.id;
                                            const url = `${state.baseUrl}/play-recording/${mType}/${id}`;

                                            if (activeAudioId === id) {
                                              // agar wahi audio chal raha hai, toggle pause
                                              setActiveAudioId(null);
                                              setActiveAudioLink("");
                                            } else {
                                              // agar dusre pe click kiya to purana band, naya play
                                              setActiveAudioId(id);
                                              setActiveAudioLink(url);
                                            }
                                          }}
                                          className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-600 text-white disabled:opacity-50"
                                        >
                                          {activeAudioId === eachList?.id ? "❚❚" : "▶"}
                                        </button>
                                      ) : eachHead.key === "percentage" ? (
                                        <ProgressLine value={parseFloat(eachList?.percentage || 0)} />
                                      ) : eachHead.key === "direction" ? (

                                        <>
                                          {eachList[eachHead.key] ?
                                            <>
                                              {eachList[eachHead.key] === "Inbound" && (
                                                <StatusChip color="red">{eachList[eachHead.key]}</StatusChip>
                                              )}
                                              {eachList[eachHead.key] === "Outbound" && (
                                                <StatusChip color="blue">{eachList[eachHead.key]}</StatusChip>
                                              )}
                                              {eachList[eachHead.key] === "Incoming" && (
                                                <StatusChip color="yellow">{eachList[eachHead.key]}</StatusChip>
                                              )}
                                              {!["Inbound", "Outbound", "Incoming"].includes(eachList[eachHead.key]) &&
                                                "--"}
                                            </>
                                            :
                                            "-"
                                          }
                                        </>
                                      ) : eachHead.key === "c_type" ? (
                                        <>
                                          {eachList[eachHead.key] ?
                                            <>
                                              {eachList[eachHead.key] == "Postpaid" ? (
                                                <StatusChip color="green">{eachList[eachHead.key]}</StatusChip>
                                              ) : (
                                                <StatusChip color="red">{eachList[eachHead.key]}</StatusChip>
                                              )}
                                            </>
                                            :
                                            "-"
                                          }

                                        </>
                                      ) : (

                                        eachList?.[eachHead?.key] ?? "-"
                                      )}
                                    </TableCell>
                                  ) : null
                                )}

                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                      {/* <div className="pt-2">
                        {!isLoading ? (
                          <div
                            className={Style.table_footer}
                            style={{ alignItems: "center" }}
                          >
                            <div className={Style.table_footer_left}>
                              {`showing 1 to ${apiData?.length} of ${tablePagination?.total || apiData?.length
                                }`}
                            </div>

                            {tablePagination ? (
                              <div className={Style.empDirectory_footer}>
                                {tablePagination?.next_page ? (
                                  <button
                                    className={Style.loadMoreBtn}
                                    onClick={() => {
                                      if (btnLoader) return;
                                      // setPageCount(pageCount + 1);
                                      setBtnLoader(true);
                                      filterData({ page: pageCount + 1, btnCall: true });
                                      // getData({
                                      //   page: tablePagination?.next_page,
                                      // });
                                    }}
                                  >
                                    {btnLoader ? (
                                      <InnerLoader
                                        className={Style.loader}
                                        textStatus={false}
                                      />
                                    ) : (
                                      "Load More"
                                    )}
                                  </button>
                                ) : null}
                              </div>
                            ) : null}

                            <div
                              className={`${Style.table_footer_left} ${Style.rightText}`}
                            ></div>
                          </div>
                        ) : (
                          <div
                            className={Style.table_footer}
                            style={{ alignItems: "center" }}
                          >
                            <div className={Style.table_footer_left}>
                              <Skeleton width={"50%"} height={15} />
                            </div>

                            <div className={Style.empDirectory_footer}>
                              <Skeleton width={"180px"} height={40} />
                            </div>

                            <div
                              className={`${Style.table_footer_left} ${Style.rightText}`}
                            ></div>
                          </div>
                        )}
                      </div> */}
                    </TableCard>
                  </>
                )}
              </div>

              {/* {console.log("tablePagination", tablePagination)} */}

              {!isLoading ? (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    {`showing 1 to ${apiData?.length} of ${tablePagination?.total || apiData?.length
                      }`}
                  </div>

                  {tablePagination ? (
                    <div className={Style.empDirectory_footer}>
                      {tablePagination?.next_page ? (
                        <button
                          className={Style.loadMoreBtn}
                          onClick={() => {
                            if (btnLoader) return;
                            // setPageCount(pageCount + 1);
                            setBtnLoader(true);
                            filterData({ page: pageCount + 1, btnCall: true });
                            // getData({
                            //   page: tablePagination?.next_page,
                            // });
                          }}
                        >
                          {btnLoader ? (
                            <InnerLoader
                              className={Style.loader}
                              textStatus={false}
                            />
                          ) : (
                            "Load More"
                          )}
                        </button>
                      ) : null}
                    </div>
                  ) : null}

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}

              {activeAudioLink && (
                <AudioPlayer
                  src={activeAudioLink}
                  onClose={() => {
                    setActiveAudioId(null);
                    setActiveAudioLink("");
                  }}
                  onPlayChange={(playing) => {
                    if (!playing) {
                      setActiveAudioId(null);
                      setActiveAudioLink("");
                    }
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div >
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          // onSave={(filters, filterName, editingFilter) => {
          //   getData({ filter: filters });
          //   setShowModalFilterTable(false);
          //   setFilterReturn(filters);
          // }}
          saveFilter={saveFilter}
          apiUrl="get-flag-to-qa-call-logs-list"
          onSave={(filters, filterName, editingFilter) => {
            setShowModalFilterTable(false);
            setFilterReturn(filters ? filters : []);
            setSelectFilterName(filterName ? filterName : "My Filter");
            setEditingFilters(editingFilter ? editingFilter : []);
            setPageCount(1);
            filterData({ filters: filters, page: 1 });
          }}
          selectFilterName={selectFilterName}
          editingFilters={editingFilters}
        />
      )
      }

      {
        showModalCustomizeTabs && (
          <CustomizeTabsPopup
            data={tableHeader}
            onClose={() => {
              setShowModalCustomizeTabs(false);
              const table = tableRef?.current;
              if (table) {
                table.style.zIndex = 1;
              }
            }}
            onPreview={(updatedHeaders) => {
              setTableHeader(updatedHeaders);
              const table = tableRef?.current;
              table.style.zIndex = 100;
            }}
            onPreviewClose={() => {
              const table = tableRef?.current;
              table.style.zIndex = 1;
            }}
            onSave={(saveHeaders) => {
              setTableHeader(saveHeaders);
              const table = tableRef?.current;
              if (table) {
                table.style.zIndex = 1;
              }
            }}
            apiUrl="get-flag-to-qa-call-logs-list"
          />
        )
      }

      {
        showAddModal && currentData !== "" && (
          <AddFullModal
            callId={currentData?.id}
            type={mType}
            onError={onError}
            onSubmit={onSuccess}
            onClose={() => {
              setAddModal(false);
              setCurrentData({});
            }}
          />
        )
      }


      {
        showQuickView && (
          <CallQuickView
            onClose={() => {
              setQuickView(false);
              setCallData({});
            }}
            id={CallData?.id}
            type={mType}
          />
        )
      }


      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default QACalls;